<div *ngIf="totalPages !== undefined" class="main-pagination">

    <div class="pg-dropdown">
        <span>Affichage</span>
        <div class="pg-nb-page-items" (click)="toggleActive($event)">
            <span id="result-per-page"> {{maxSize}} résultats par page</span>
            <fa-icon *ngIf="dropDownIsActive" [icon]="faAngleUp"></fa-icon>
            <fa-icon *ngIf="!dropDownIsActive" [icon]="faAngleDown"></fa-icon>
        </div>
        <div *ngIf="dropDownIsActive" class="dropdown-menu is-open">
            <div class="dropdown-content">
                <div *ngFor="let sizePage of listSizeItemsPerPage" class="dropdown-item"
                    (click)="selectSizePage($event, sizePage)">
                    {{sizePage}} résultats par page
                </div>
            </div>
        </div>
    </div>

    <ul *ngIf="totalPages.length > 1" class="pg-controls">
        <li id="pg-first" class="pg-element" (click)="getFirst($event)"
            [ngClass]="{'disabled': currentPage === FIRST_PAGE}">
            <fa-icon [icon]="faAngleDoubleLeft"></fa-icon>
        </li>
        <li id="pg-back" class="pg-element" (click)="getPrevious($event)"
            [ngClass]="{'disabled': currentPage === FIRST_PAGE}">
            <fa-icon [icon]="faAngleLeft"></fa-icon>
        </li>
        <li *ngFor="let iteratedElt of totalPages | slice:startPage:endPage; let i = index;"
            class="pg-element" [ngClass]="{'isCurrentPage': i+startPage === currentPage}"
            (click)="getPage($event, i+startPage)">
            {{1+i+startPage}}
        </li>
        <li id="pg-next" class="pg-element" (click)="getNext($event)"
            [ngClass]="{'disabled': currentPage === totalPages.length - 1}">
            <fa-icon [icon]="faAngleRight"></fa-icon>
        </li>
        <li id="pg-last" class="pg-element pg-arrow" (click)="getLast($event)"
            [ngClass]="{'disabled': currentPage === totalPages.length - 1}">
            <fa-icon [icon]="faAngleDoubleRight "></fa-icon>
        </li>
    </ul>
</div>
